import * as z from "zod";
import { returnsAnalyticsDataQualitySchema } from "./returns-analytics-shared";

export const getReturnsVelocityBenchmarksInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
});
export type GetReturnsVelocityBenchmarksInput = z.infer<
  typeof getReturnsVelocityBenchmarksInputSchema
>;

const benchmarkSchema = z.object({
  medianDays: z.number().min(0).nullable(),
  p90Days: z.number().min(0).nullable(),
  sampleSize: z.number().int().min(0),
});
export type ReturnsVelocityBenchmark = z.infer<typeof benchmarkSchema>;

export const getReturnsVelocityBenchmarksOutputSchema = z.object({
  /** HubSpot deal created -> `onboarding_v2_progress.first_revenue_at`. */
  demoSetToLive: benchmarkSchema,
  /** `completed_at` -> `first_revenue_at`. */
  completedToFirstRevenue: benchmarkSchema,
  /** `first_revenue_at` -> `churned_at`. */
  firstRevenueToChurn: benchmarkSchema,
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsVelocityBenchmarksOutput = z.infer<
  typeof getReturnsVelocityBenchmarksOutputSchema
>;

export const getReturnsVelocityBenchmarks = {
  name: "getReturnsVelocityBenchmarks" as const,
  input: getReturnsVelocityBenchmarksInputSchema,
  output: getReturnsVelocityBenchmarksOutputSchema,
};
